// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aIyfd","indicator":"styles_indicator__O02Vx"};